module.exports = __webpack_public_path__ + "img/logo.2099cbf1.png";